<template>
	<div id='whellCon' class="wheelflag freeact">
		<div id="mask"></div>
		<p class='titlebgm'>
            <img src="~assets/images/video.png" alt="" class='video'>
            <span class="wheel-title">{{uiTitle}}</span>
        </p>
		<div id="lottery" class="actbox">
			<img src="~assets/images/circle.png" alt="" class='circle'>
			<div id='lotteryCon'>
                <div v-for='(item,index) in wheelListdata' :key ='index' style="padding:0;" >
					<div class="wheel-lottery-unit" v-if="item.icon" :class="item.icon?'bg':''" :id='item.awardId' :awardIdPointer='item.awardIdPointer' :index='item.ind'>
						<img class='icon' :src="item.icon" alt="">
						<b class='awardName'>
							<span class="count" v-show="item.shortName == '现金' || item.shortName == '金币'">{{item.shortName == '现金' ? item.awardQuantity / 100 + '元': item.awardQuantity}}</span>
							<span class='awardNames'>{{item.shortName}}</span>
						</b>
						<span class="right_trapezoid" v-show="item.awardQuantity > 1 && item.shortName != '现金' && item.shortName != '金币'">{{item.awardQuantity}}</span>
						<div class='show' :class="'show-'+item.ind"></div>
					</div>
					<div v-else @click='activeclick'>
						<div :class="btnstate?'btnafter':'btnbefore'">
							免费<br>播放
						</div>
					</div>
				</div>
			</div>
		</div>
		<img class="hand" src="~assets/images/hand.png" alt="" v-show='freeactflag'>
		<p class="dailySerpluss" v-if="freeNums>0" :style="{zIndex:dailySerplussZindex,bottom:'0.1rem'}">
			您今日还有
			<span class="backcount" style="color:yellow;font-size:0.17rem">{{freeNums}}</span>
			次
			<span class="backcount" style="color:yellow;font-size:0.17rem">免费</span>
			抽奖机会
		</p>
		<div class='dailySerpluss' v-else :style="{zIndex:dailySerplussZindex}">
			<p v-if="userSerplus>0" class='dailySerplus'>
				您今日还有
				<span class='wheel-counts' ref="wheel-counts">{{userSerplus}}</span>
				次抽奖机会
			</p>
			<p v-else class='dailySerplus'>幸运好礼，等你来拿</p>
		</div>
		
	</div>
</template>
<script>
	import $ from 'jquery'
	import { mapState,mapMutations } from 'vuex'
	import config from "@/../config"
	import primaryApi from '@/utils/primaryApi'
	import qs from 'qs'
	import active from'@/utils/axios/index'

	export default {
		computed:{
			...mapState([
				'uuid',
				'activityStatus',
				'activityId',
				'time',
				'firstEntry',
				'freeact',
				'guide'
			])
		},
		data(){
			return {
				wheelListdata: [],//大转盘需要展示奖品
				uiTitle: "",//转盘的标题
				userSerplus: 0,//可用次数
				awardL: [],//奖品数组
				btnstate: false,//按钮展示的状态
				isclick: true,//是否点击过
				lottery: {
					index: -1,    //当前转动到哪个位置，起点位置
					count: 8,    //总共有多少个奖品位置，9宫格就是8个奖品位置
					timer: 0,    //setTimeout的ID，用clearTimeout清除
					speed: 10,    //初始转动速度
					times: 0,    //转动次数
					cycle: 50,    //转动基本次数：即至少需要转动多少次再进入抽奖环节
					prize: 0,    //默认中奖位置，放默认奖品
					init: function (id) {
						if ($("#" + id).find(".wheel-lottery-unit").length > 0) {
							var $lottery = $("#" + id);
							var $units = $lottery.find(".wheel-lottery-unit");
							this.obj = $lottery;
							this.count = $units.length;
							$lottery.find(".show-" + this.index).show();
						};
					},
					roll: function () {
						var index = this.index;//当前转动位置
						var count = this.count;//转动次数
						var lottery = this.obj;
						$(lottery).find(".show-" + index).hide();
						index += 1;
						if (index > count - 1) {
							index = 0;
						};
						$(lottery).find(".show-" + index).show();
						this.index = index;
						return false;
					},
					stop: function (index) {
						this.prize = index;
						return false;
					}
				},
				freeNums: '',//抽奖的免费次数
				totalFreeNums:'',//开始抽奖的总次数
				missionflag: '',//是否去任务引导		
				freeactflag: false,//判断是否展示转盘中的手指
				dailySerplussZindex: '0'
			}
		},
		
		created(){
			this.getWheel()
		},
		methods:{
			getWheel(){
				active.getWheel(config.API_HOST +'/apiserv/api/award/getWheel', {
					awardIdPointer: this.awardIdPointer,
					uuid: this.uuid,
					activityId: this.activityId
				}).then((res) => {
					if (res.return_code == 200) {
						this.freeNums = res.data.freeNums//免费次数
						this.totalFreeNums = res.data.totalFreeNums//总的免费次数
						this.uiTitle = res.data.uiTitle;
						this.userSerplus = res.data.userSerplus;

						//按照祥林的要求进行展示
						for(var i=0;i<res.data.wheelList.length;i++){
							res.data.wheelList[i].ind = i
						}
						//按照祥林的要求进行展示
						this.wheelListdata.push(res.data.wheelList[0])
						this.wheelListdata.push(res.data.wheelList[1])
						this.wheelListdata.push(res.data.wheelList[2])
						this.wheelListdata.push(res.data.wheelList[7])
						this.wheelListdata.push({})
						this.wheelListdata.push(res.data.wheelList[3])
						this.wheelListdata.push(res.data.wheelList[6])
						this.wheelListdata.push(res.data.wheelList[5])
						this.wheelListdata.push(res.data.wheelList[4])
						this.activemove()//判断免费次数，从而判断是否第一次进入
					} else {
						this.tipConshow(res.return_msg);
					}
				})
			},
			activemove(){
				var freeact = []
				this.firstEntry.forEach((i) => {
					if(i.activeid == this.activityId){
						if(i.firstEntry){
							if(this.freeNums >0){
								this.freeactflag = true
								this.dailySerplussZindex = 105;
								var obj = {
									activeid: this.activityId,
									freeact: true
								}
								freeact.push(obj)
							}else if(this.freeNums == -1 || this.freeNums == 0){
								this.freeactflag = false
								this.dailySerplussZindex = 0;
								var obj = {
									activeid: this.activityId,
									freeact: this.freeNums
								}
								freeact.push(obj)
							}else{
								this.freeactflag = false
								this.dailySerplussZindex = 0;
								var obj = {
									activeid: this.activityId,
									freeact: false
								}
								freeact.push(obj)
							}
							this.$store.commit({
								type:'setfreeact',
								freeact: freeact
							})
						}
					}
				})
			},
			lock(){
				if (this.activityStatus == 0) { //活动展示期
					this.tipConshow('【' + this.time + '】开启活动，请耐心等待');
					this.$tea('event_activemodal_ffwheelbtn_20201', { 'activityId': this.activityId, guide:this.guide?this.guide:false });//数据埋点
					return false;
				} else if (this.activityStatus == 1) {//活动开始
					return true;
				} else if (this.activityStatus == 2) {//活动结束，但在展示阶段
					this.tipConshow("活动已结束，请等待下次活动");
					this.$tea('event_activemodal_ffwheelbtn_20201', { 'activityId': this.activityId, guide:this.guide?this.guide:false });//数据埋点
					return false;
				} else {//活动关闭
					this.tipConshow("活动已关闭，请等待下次活动");
					this.$tea('event_activemodal_ffwheelbtn_20201', { 'activityId': this.activityId, guide:this.guide?this.guide:false });//数据埋点
					return false;
				}
			},
			activeclick(){
				var continu = this.lock();
				if(continu){
					this.btnstate = true
					//判断是否有免费的次数
					if(this.freeNums>0){
						this.isclick = false;
						window.showAdVideoSuccess()
					}else{
						if (this.userSerplus != 0) {//今日次数不为0
							//开始抽奖
							if (this.isclick) {
								this.isclick = false;
								this.$tea('event_activemodal_adwheelbtn_20201', { 'activityId': this.activityId, guide:this.guide?this.guide:false });//数据埋点
								primaryApi.playADVideo();
							}
						} else {//今日次数为0
							this.tipConshow("今日抽奖机会已用完，请明日再来")
							this.$tea('event_activemodal_ffwheelbtn_20201', { 'activityId': this.activityId, guide:this.guide?this.guide:false });//数据埋点
						}
					}
				}
			},
			wheel(){
				active.wheel(config.API_HOST +'/apiserv/api/award/wheel',qs.stringify({
					awardIdPointer: this.awardIdPointer,
					uuid: this.uuid,
					activityId: this.activityId
				})).then((res) => {
					if (res.return_code == 200) {
						var wheelStatus = res.data.wheelStatus
						if (wheelStatus == 0) {//条件未达标
							this.$tea('event_activemodal_wheelbtn_20201', { 'activityId': this.activityId, 'wheelStatus': wheelStatus, guide:this.guide?this.guide:false });//数据埋点
							this.tipConshow("条件未达标");
							this.isclick = true
						} else if (wheelStatus == 1) {//抽奖成功
							var awardId = res.data.awardList[0].awardId;
							this.$tea('event_activemodal_wheelbtn_20201', { 'activityId': this.activityId, 'wheelStatus': wheelStatus, 'awardId': awardId, guide:this.guide?this.guide:false });
							this.freeNums = res.data.freeNums//免费次数
							var movemission = this.totalFreeNums - this.freeNums;
							//判断是不是第一次抽奖
							this.firstEntry.forEach((i) => {
								if(i.activeid == this.activityId && i.firstEntry == true && movemission == 1){
									this.missionflag = true
								}else{
									this.missionflag = false
								}
							})
							this.lottery.speed = 100;
							this.lottery.prize = $("#" + awardId).attr('index');
							this.awardL = res.data.awardList;
							this.userSerplus = res.data.dailySerplus;
							if (typeof Android != 'undefined') { //运行环境为小游戏才需要执行
								//判断获得的奖励是否是现金或者金币
								for (var i = 0; i < this.awardL.length; i++) {
									if (this.awardL[i].awardName == '现金') {
										var bool = Android.addUserBalance(this.awardL[i].awardQuantity / 100, 'CASH')
									} else if (this.awardL[i].awardName == '金币') {
										var bool = Android.addUserBalance(this.awardL[i].awardQuantity, 'GOLD')
									}
								}
							}
							this.roll()
						} else if (wheelStatus == 2) {//抽奖失败
							this.tipConshow('抽奖失败');
							this.isclick = true
						}
					} else {
						this.tipConshow(res.return_msg);
						this.isclick = true
					}
				})
			},
			roll(){
				var that = this
				this.lottery.times += 1;
				this.lottery.roll();
				if (this.lottery.times > this.lottery.cycle + 10 && this.lottery.prize == this.lottery.index) {
					clearTimeout(this.lottery.timer);
					this.lottery.times = 0; 
					//显示中奖信息
					function hide() {
						$('.show-' + that.lottery.index).hide()
					}
					function show() {
						$('.show-' + that.lottery.index).show()
					}
					function showTip() {
						that.isclick = true
						that.firstEntry.forEach((i) => {
							if (i.activeid == that.activityId) {
								if (i.firstEntry) {
									that.tipConshow2(that.awardL, that.missionflag);
								} else {
									that.tipConshow2(that.awardL)
								}
								that.freeactflag = false;
							}
						})
					}
					function showcent() {
						that.btnstate = false
					}
					//闪动三下
					setTimeout(hide, 300)
					setTimeout(show, 600)
					setTimeout(hide, 900)
					setTimeout(show, 1200)
					setTimeout(hide, 1500)
					setTimeout(show, 1800)
					//显示中奖信息
					setTimeout(showTip, 2100)
					setTimeout(showcent, 2400)
				} else {
					//速度控制
					if (this.lottery.times < this.lottery.cycle) {
						this.lottery.speed -= 10;
					} else if (this.lottery.times == this.lottery.cycle) {
						var index = this.lottery.prize;
					} else {
						if (this.lottery.times > this.lottery.cycle + 10 && ((this.lottery.prize == 0 && this.lottery.index == 7) || this.lottery.prize == this.lottery.index + 1)) {
							this.lottery.speed += 100;
						} else {
							this.lottery.speed += 20;
						}
					}
					if (this.lottery.speed < 40) {
						this.lottery.speed = 40;
					};
					//延时递归调用
					this.lottery.timer = setTimeout(this.roll, this.lottery.speed);
				}
			}
		},
		mounted(){
			//广告播放时安卓那边要回调的函数
			/* 小游戏播放广告回调 */
			window['showAdVideoSuccess'] = () => {//播放完成
				// var count = 28
				// var nowcount = 0;//当前的变化位置
				// count -= 1;
				this.lottery.init('lottery');
				this.wheel()
			}
			window['showAdVideoNotComplete'] = () => {
				this.tipConshow('未完整播放');
				this.isclick = true;
			}
			window['showAdVideoFailed'] = () => {
				this.tipConshow('视频播放失败');
				this.isclick = true;
			}
			/* 乐园播放广告回调 */
			window['playAdFinish'] = () => {//播放完成
				this.lottery.init('lottery');
				this.wheel();
			}
			window['playAdFailed'] = () => {
				this.tipConshow('视频播放失败');
				this.isclick = true;
			}
		} 
	}
</script>
<style lang="less" scoped>
button, p{
	margin: 0;
	padding: 0;
}
#whellCon {
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	margin-top:0.2rem;
	position: relative;
}
#mask{
	position: absolute;
	top: 0.56rem;
	left: 50%;
	margin-left: -1.66rem;
	width: 3.32rem;
	height: 3.37rem;
	z-index: 1000;
	border-radius: 0.12rem;
	display: none;
}
.titlebgm {
	width: 80%;
	height: 0.56rem;
	margin-left: 10%;
	background: url('~assets/images/titleBgm.png') no-repeat top;
	background-size: contain;
	font-size: 0.20rem;
	font-family: PingFangSC-Semibold, sans-serif;
	color: rgba(255, 255, 255, 1);
	line-height: 0.5rem;
	text-shadow: 0 0.02rem 0.02rem rgba(214, 69, 6, 1);
	position: relative;
	display:flex;
	justify-content: center;
}
.titlebgm .video{
	width: 0.4rem;
	height: 0.4rem;
	margin-top:0.05rem;
}
#lottery {
	width: 3.32rem;
	height: 3.37rem;
	margin:0 auto;
	border-radius: 0.05rem;
	background: url('~assets/images/wheelBg.png') no-repeat center;
	background-size: contain;
	display: flex;
	position: relative
}
#lottery .circle {
	width: 100%;
	height: 90%;
	position: absolute;
	top: -0.04rem;
}
#lotteryCon {
	width: 2.8rem;
	margin: 0.22rem auto;
}
#lotteryCon>div {
	margin: auto;
	text-align: center;
	width: 0.87rem;
	height: 0.85rem;
	border-radius: 0.04rem;
	position: relative;
	background-size: 115%;
	position: relative;
	float: left;
	margin: 0.03rem;
	padding: 0.09rem 0.15rem 0.13rem 0.15rem;
}
#lotteryCon .wheel-lottery-unit {
	width: 0.87rem;
	height: 0.85rem;
	background: #fff;
	border-radius: 0.04rem;
}
#lotteryCon .wheel-lottery-unit .icon {
	width: 0.4rem;
	height: 0.4rem;
	border-radius: 0.04rem;
	position: absolute;
	top: 0.1rem;
	left: 0.24rem;
	z-index: 100;
}
.awardName {
	position: absolute;
	width: 100%;
	height: 0.12rem;
	line-height: 0.12rem;
	border-radius: 0 0 0.02rem 0.02rem;
	opacity: 0.6;
	bottom: 0.1rem;
	left: 0;
	color: #333333;
	font-size: 0.12rem;
	z-index: 100;
}
.count {
	color: #FA584C;
	margin-left: 0.05rem;
}
#lottery .right_trapezoid {
	display: block;
	position: absolute;
	top: 0;
	right: -0.01rem;
	max-width: 0.6rem;
	height: 0.2rem;
	font-size: 0.12rem;
	line-height: 0.2rem;
	padding: 0 0.05rem;
	background: url('~assets/images/signRight.png') no-repeat left;
	border-top-right-radius: 0.06rem;
	color: #FFF;
	border: none;
	background-size: cover;
	z-index: 999;
}
.show {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 0;
	background: rgba(247, 254, 0, 1);
	display: none;
	border-radius: 0.06rem;
}
.btnbefore{
	width: 0.87rem;
	height: 0.85rem;
	background: url('~assets/images/1.gif') no-repeat center;
	background-size: 134%;
	color: #fff;
	text-align: center;
	font-size:0.20rem;
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.btnafter {
	width: 0.87rem;
	height: 0.85rem;
	background: url('~assets/images/play.png') no-repeat center;
	background-size: 134%;
	color: #fff;
	text-align: center;
	color: #fff;
	font-size:0.20rem;
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.dailySerpluss {
	width: 3.1rem;
	position: absolute;
	bottom: 0rem;
	left: 50%;
	margin-left: -1.6rem;
	font-size: 0.15rem;
	font-weight: 400;
	color: rgba(255, 223, 222, 1);
	text-align: center;
	z-index: 101;
}
.backcount{
	font-size: 0.2rem;
}
.dailySerplus {
	padding: 0 0.1rem;
	box-sizing: border-box;
	height: 0.13rem;
	font-weight: 400;
	color: rgba(255, 223, 222, 1);
	line-height: 0.13rem;
	width: 100%;
	text-align: center;
	position: absolute;
	bottom: 0.15rem;
}
.dailySerplus span {
	height: 0.13rem;
	font-size: 0.2rem;
	font-weight: 500;
	color: rgba(247, 254, 0, 1);
	line-height: 0.13rem;
	margin: 0 0.05rem;
}
.hand{
	z-index: 101;
	position: absolute;
	width: 0.7rem;
	top: 60%;
	left: 55%;
}
</style>